import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;

import Viewer from "v-viewer";

// Vue.use(VueGtag, {
//   config: {
//     id: "UA-140122993-8",
//     params: {
//       send_page_view: true
//     }
//   }
// });
Vue.use(Viewer);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
